import React, { useState } from 'react';
import '../css/App.css';

import { Container } from 'react-bootstrap'
import NavigationBar from '../layouts/NavigationBar'
import WebRoute from './WebRoute'
import AuthService from "./AuthService";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faTimes } from '@fortawesome/free-solid-svg-icons'

const App = () => {
  const [bgColor, setBGColor] = useState("bg-lightness-blue");
  
  const handleBackground = (v) => {
    // setBGColor(v.backgroundColor)
    document.body.classList.add(v.backgroundColor ? v.backgroundColor : "bg-lightness-blue");
  }

  return (
      <div>
          <NavigationBar />
          <Container fluid className={`px-0 ${bgColor ? "" : ""}`}>
            <WebRoute onChange={value => handleBackground(value)} />
          </Container>
      </div>
    )
}

export default App;



